import React, { useEffect } from 'react';
import _get from 'lodash/get';
import classNames from 'classnames';
import { PresetItem } from './MAPPING_PRESETS';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';

interface Props {
  mapping: any;
  onChange: (newMapping: any) => void;
  flexDirection?: 'row' | 'column';
  subSource: string;
  collectionMapping: any;
  collectionItemType: string;
  collectionItemCustomType: string;
  rootKey: string;
}

function CollectionMapping({
  mapping,
  flexDirection = 'row',
  onChange,
  subSource,
  collectionMapping,
  collectionItemType,
  collectionItemCustomType,
  rootKey,
}: Props) {
  const classes = useStyles();

  function handleTypeChange(e: any) {
    const newType = e.target.value;
    const defaultSubSource = collectionMapping.itemProperties.find((i: any) => !!i.isDefault);

    onChange({
      ...mapping,
      collectionItemType: newType,
      collectionItemCustomType: newType === 'custom' ? '' : null,
      customProps: {
        ..._get(mapping, `customProps`, {}),
        mappingSubSource: `${rootKey}.${_get(defaultSubSource, 'key')}`,
        subSource: _get(defaultSubSource, 'key'),
      },
    });
  }

  function handlePropertiesChange(e: any) {
    onChange({
      ...mapping,
      customProps: {
        ..._get(mapping, `customProps`, {}),
        subSource: e.target.value,
        mappingSubSource: `${rootKey}.${e.target.value}`,
      },
    });
  }

  function handleCustomTypeChange(e: any) {
    onChange({
      ...mapping,
      collectionItemCustomType: e.target.value,
    });
  }

  return (
    <div className={classes.root}>
      <Typography variant="subtitle1" component="div">
        <strong>Collection Mapping Settings</strong>
      </Typography>
      <div
        className={classNames(classes.formRoot, {
          [classes.formRootColumn]: flexDirection === 'column',
        })}
      >
        <FormControl>
          <InputLabel id={`${subSource}-CollectionMapping-type-select`}>Item Type</InputLabel>
          <Select
            labelId={`${subSource}-CollectionMapping-type-select`}
            value={collectionItemType}
            onChange={handleTypeChange}
          >
            {collectionMapping.types.map((t: PresetItem) => {
              return (
                <MenuItem value={t.key} key={t.key}>
                  {t.displayName || t.key}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        {collectionItemType === 'custom' && (
          <FormControl>
            <TextField
              label="Custom Type"
              value={collectionItemCustomType}
              onChange={handleCustomTypeChange}
              error={(collectionItemCustomType || '').length === 0}
            />
          </FormControl>
        )}
        <FormControl>
          <InputLabel id={`${subSource}-CollectionMapping-properties-select`}>
            Item Property
          </InputLabel>
          <Select
            labelId={`${subSource}-CollectionMapping-properties-select`}
            value={subSource}
            onChange={handlePropertiesChange}
          >
            {collectionMapping.itemProperties.map((t: PresetItem) => {
              return (
                <MenuItem value={t.key} key={t.key}>
                  {t.key}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme: any) => {
  return {
    root: {
      paddingTop: theme.spacing(),
    },
    formRoot: {
      marginTop: theme.spacing(0.5),
      display: 'flex',
      '& > div': {
        flex: 'auto',
        marginBottom: theme.spacing(0.5),
        maxWidth: 200,
      },
      '& > div:not(:last-child)': {
        marginRight: theme.spacing(4),
      },
    },
    formRootColumn: {
      flexDirection: 'column',
    },
  };
});

export default CollectionMapping;
